



















import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import Form, {
  InputData,
  OnSubmitReturn,
} from '@/main-components/common/Form.vue';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import replaceFormInputValue from '@/utils/form/replace-form-input-value';
import cookie, { COOKIE } from '@/utils/cookie';

@Component({
  components: {
    Modal,
    Form,
  },
})
export default class ModalReview extends Vue {
  userStore: UserStoreInterface = UserStore;

  openModal: any = null;
  closeModal: any = null;

  inputs: InputData[] = [
    {
      name: 'description',
      value: '',
      placeholder: 'Apa pendapat anda tentang MySoalan? 🤔',
      type: 'textarea',
      isRequired: true,
      maxLength: 1000,
    },
  ];

  async submitReview(bodyRequest: any): Promise<OnSubmitReturn | null> {
    await this.userStore.postReview(bodyRequest.description);

    if (this.userStore.error) {
      return { error: this.userStore.error };
    } else {
      this.$toasted.global.mainToast({
        message: 'Terima kasih. Review anda telah dihantar 🙏🏻',
      });
      replaceFormInputValue(this.inputs, 'description', '');
      cookie.set(COOKIE.HAS_REVIEWED, 'true', { sameSite: 'strict' });
      this.$sendMpEvent({ event: this.$mp_value.ReviewSubmit });
    }

    return null;
  }

  mounted() {
    this.$emit('openModalReview', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }
}
